import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-co-owner-icon',
  templateUrl: './co-owner-icon.component.html',
  styleUrls: ['./co-owner-icon.component.scss']
})
export class CoOwnerIconComponent implements OnInit {
  @Input() tooltip!: string;

  constructor() {}

  ngOnInit() {}
}
